import { createContext } from 'react';

import { BasketItem, ProductService, ProductWithAttributes, SFCCBasket } from '@gn-audio/jss-core';

export interface IBasketContext {
  toggleBasket: () => void;
  closeBasket: () => void;
  isBasketOpen: boolean;
  openMyAccountView: () => void;
  closeMyAccountView: () => void;
  isMyAccountViewOpen: boolean;
  isEmailCartOpen: boolean;
  isEmailCartSubmitted: boolean;
  addProducts: (items: BasketItem[]) => void;
  setQuantity: (itemId: string, sku: string, quantity: number) => Promise<void>;
  patchProduct: (
    itemId: string,
    quantity: number,
    services?: ProductService[],
    engravingMessage?: string
  ) => void;
  applyCoupon: (couponCode: string) => Promise<void>;
  removeCoupon: (couponItemId: string) => Promise<void>;
  removeProduct: (itemId: string) => Promise<void>;
  setEngravingMessage: (
    itemId: string,
    quantity: number,
    engravingMessage: string
  ) => Promise<void>;
  toggleEmailCart: () => void;
  submitEmailCart: () => void;
  basket: SFCCBasket | undefined;
  busy: boolean;
  setBusy: (isBusy: boolean) => void;
  groups: ProductWithAttributes[];
  createNewSharedBasket: () => Promise<string> | undefined;
}

const BasketContext = createContext<IBasketContext>({
  toggleBasket: () => null,
  closeBasket: () => null,
  openMyAccountView: () => null,
  closeMyAccountView: () => null,
  addProducts: () => {},
  setQuantity: () => Promise.resolve(),
  applyCoupon: () => Promise.resolve(),
  patchProduct: () => Promise.resolve(),
  removeCoupon: () => Promise.resolve(),
  removeProduct: () => Promise.resolve(),
  setEngravingMessage: () => Promise.resolve(),
  toggleEmailCart: () => null,
  submitEmailCart: () => null,
  isMyAccountViewOpen: false,
  isBasketOpen: false,
  isEmailCartOpen: false,
  isEmailCartSubmitted: false,
  basket: undefined,
  busy: false,
  setBusy: () => null,
  groups: [],
  createNewSharedBasket: () => Promise.resolve(''),
});

export { BasketContext };
